module.exports = "<h5><b>Home Improvement Sales Person (HIS) Registration</b></h5>\n<br />\n<p>\n  If you've completed HIS registration with the CSLB, then enter number here to unlock full access to sales features including the following:\n</p>\n<br />\n<ul>\n  <li>Apply button</li>\n  <li>Know before you go</li>\n  <li>Pipeline and Search</li>\n  <li>Transfer a project</li>\n</ul>";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/user/personalInformation/contractorUserLicenseRegistration/contractorUserLicense-popover-template.html
// module id = 365
// module chunks = 1